module.exports = __webpack_public_path__ + "img/sport_bg2.0bed2bc7.png";